import type { BillingStateQuery } from '../types/generated-new';

export const getIsInvoiceReady = (
  billingState: BillingStateQuery['supplierBillingState'] | undefined
) => {
  if (!billingState) return false;

  return billingState.canAccess || billingState.canAccessBypassed;
};
